const NotFoundScreen: React.FC = () => {
  return <div>494</div>;
};

export default NotFoundScreen;
